import { css } from 'emotion';

export const activityFooter = css`
  display: flex;
  min-height: 69px;
  padding: 20px 22px 10px;
  align-items: center;
`;

export const textArea = theme => css`
  height: 40px;
  border-radius: 20px;
  border: 1px solid ${theme.color.grey1} !important;
  background: ${theme.color.grey4} !important;
  max-height: 86px;
  resize: none;
  margin: 0 10px;
  padding: 9px 15px !important;
  line-height: 22px;
  :focus {
    outline: none;
  }
  ::-webkit-scrollbar {
    width: 0 !important;
  }
`;

export const sendButton = theme => css`
  svg {
    height: 24px;
    width: 24px;
  }

  :hover:not(:disabled),
  :focus:not(:disabled) {
    fill: ${theme.color.accent};
    transform: scale(1.3);
  }
`;
